import React, { useContext, useEffect, useState } from "react";
import { BaseContext } from "../../contexts/BaseContext";
import TmsStringUtils from "../../utils/tms-string-utils/tms-string-utils";
import "./home-v2.scss";
import TmsDashboardService from "../../services/tms-dashboard.service";
import { Col, Row, Statistic, Progress, Button } from "antd";
import {
  children,
  dutyPass,
  idCard,
  priest,
  vehicle,
  vritix_logo,
} from "../../assets/images/tms-image-list";
import TmsDatepickerRange from "../../components/tms-customs/tms-datepicker-range";
import moment from "moment";
const TmsHomeNew = () => {
  const { userDetails } = useContext(BaseContext);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [bookingFromDate, setBookingFromDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [bookingToDate, setBookingToDate] = useState(
    moment().format("YYYY-MM-DD")
  );

  useEffect(() => {
    fetchApi();
  }, []);

  const fetchApi = async () => {
    setLoading(true);
    try {
      const data = await TmsDashboardService.getDashboardNew(
        moment(bookingFromDate).format("YYYY-MM-DD"),
        moment(bookingToDate).format("YYYY-MM-DD")
      );
      setData(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  return (
    <div className="dashboard-v2">
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ textAlign: "left", fontSize: "24px", margin: 0 }}>
          Hello,
          <span>
            {TmsStringUtils.CaptilizeWords(
              userDetails?.user?.displayName ?? userDetails?.user?.phone
            )}
          </span>
        </h2>
        <Row style={{ alignItems: "center", gap: "10px" }}>
          <TmsDatepickerRange
            className={"m-0"}
            to={bookingToDate}
            from={bookingFromDate}
            setFrom={setBookingFromDate}
            setTo={setBookingToDate}
            size={"large"}
          />{" "}
          <Button
            type="primary"
            style={{ marginTop: "4px" }}
            onClick={() => fetchApi()}
          >
            Search
          </Button>
        </Row>
      </div>
      {loading ? (
        <div style={{ width: "100%", height: "100%" }}>
          <img src={vritix_logo} height={30} width={30} />
        </div>
      ) : (
        <>
          <Row style={{ gap: 10 }}>
            <div
              style={{
                display: "flex",
                backgroundColor: "#e7dbec",
                borderRadius: "20px",
                padding: "10px 20px",
                width: "calc(50% - 10px)",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h2 style={{ textAlign: "left" }}>
                Children Tags Issued <br />
                <b>{data["childrenTag"]?.passesIssued ?? 0}</b>
              </h2>

              <img src={children} alt="" height={50} />
            </div>

            <div
              style={{
                backgroundColor: "#d8ebff",
                borderRadius: "20px",
                padding: "10px 20px",
                width: "50%",
                fontSize: "14px",
              }}
            >
              <h2 style={{ fontWeight: 700, textAlign: "left" }}>
                Bhavani Deeksha
              </h2>
              <Progress
                percent={(
                  (data["shivadeekshaPass"]?.ticketsScanned /
                    data["shivadeekshaPass"]?.ticketsIssued) *
                  100
                ).toFixed(1)}
                strokeColor={"#F58220"}
                trailColor="#FACDA6"
                style={{ padding: "10px" }}
              />
              Issued: <b>{data["shivadeekshaPass"]?.ticketsIssued ?? 0}</b>
            </div>
          </Row>
          <Row style={{ gap: 10 }}>
            <div className="box-wrapper" style={{ width: "calc(50% - 10px)" }}>
              <div className="box  border-right">
                <p className="heading-main">Duty Passes</p>
                <div className="stats">
                  <div className="inner-box ">
                    <p>Total Issued</p>
                    <h1>{data["dutyPass"]?.passesIssued ?? 0}</h1>
                  </div>
                  <img src={dutyPass} alt="" />
                </div>
                <div className="stats">
                  <div className="inner-box ">
                    <p>Total Scanned</p>
                    <h1>{data["dutyPass"]?.passesScanned ?? 0}</h1>
                  </div>
                </div>
              </div>
              <div className="box">
                <p className="heading-main">Vehicle Passes</p>
                <div className="stats">
                  <div className="inner-box">
                    <p>Total Issued</p>
                    <h1>{data["vehiclePass"]?.passesIssued ?? 0}</h1>
                  </div>
                  <img src={vehicle} alt="" />
                </div>
                <div className="stats">
                  <div className="inner-box">
                    <p>Total Scanned</p>
                    <h1>{data["vehiclePass"]?.passesScanned ?? 0}</h1>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="box-wrapper"
              style={{ width: "50%", backgroundColor: "rgb(22 84 120)" }}
            >
              <div className="box border-right">
                <p className="heading-main">Special Seva Tickets</p>
                <div className="stats">
                  <div className="inner-box">
                    <p>Total Issued</p>
                    <h1>{data["pagaPass"]?.passesIssued ?? 0}</h1>
                  </div>
                  <img src={priest} alt="" />
                </div>
                <div className="stats">
                  <div className="inner-box">
                    <p>Total Scanned</p>
                    <h1>{data["pagaPass"]?.passesScanned ?? 0}</h1>
                  </div>
                </div>
              </div>
              <div className="box">
                <p className="heading-main">Employee Passes</p>
                <div className="stats">
                  <div className="inner-box">
                    <p>Total Issued</p>
                    <h1>{data["employeePass"]?.passesIssued ?? 0}</h1>
                  </div>
                  <img src={idCard} alt="" />
                </div>
                <div className="stats">
                  <div className="inner-box">
                    <p>Total Scanned</p>
                    <h1>{data["employeePass"]?.passesScanned ?? 0}</h1>
                  </div>
                </div>
              </div>
            </div>
          </Row>

          {/* <Row>
            <Col
              span={24}
              style={{
                backgroundColor: "#f5e9df",
                borderRadius: "20px",
              }}
            >
              <p
                style={{
                  backgroundColor: "var(--secondary-color)",
                  color: "#fff",
                  fontSize: "24px",
                  borderTopLeftRadius: "20px",
                  borderTopRightRadius: "20px",
                }}
              >
                Walkers
              </p>
              <Row className="flex" style={{ paddingBottom: "14px" }}>
                <Col span={6}>
                  <Statistic
                    className="a-stats"
                    style={{ cursor: "pointer" }}
                    title=" Walkers Issued"
                    value={data["walkersTag"]?.totalAssigned ?? 0}
                  />
                </Col>
                <Col span={6}>
                  <Statistic
                    className="a-stats"
                    style={{ cursor: "pointer" }}
                    title=" Walker Scanned"
                    value={data["walkersTag"]?.totalScanned ?? 0}
                  />
                </Col>

                {data["walkersTag"]?.checkpoints?.map((item) => {
                  return (
                    <>
                      <Col span={6} key={item.checkpointNo}>
                        <Statistic
                          className="a-stats"
                          style={{ cursor: "pointer" }}
                          title={`Checkpoint ${item.checkpointNo} Scanned`}
                          value={item?.totalScanned ?? 0}
                        />
                      </Col>
                    </>
                  );
                })}
              </Row>
            </Col>
          </Row> */}
        </>
      )}
    </div>
  );
};

export default TmsHomeNew;
